import { useState, useEffect, useCallback } from 'react';
import API from 'api/api';
import { translateApiError } from 'i18n/translateApiError';

export function useGetAllUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch all users
  const fetchAllUsers = useCallback(async (signal) => {
    setLoading(true);
    setError(null);

    try {
      const res = await API.get('/users', { signal });
      if (!signal.aborted) {
        setUsers(res?.data || []);
      }
      return res?.data || [];
    } catch (err) {
      if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') {
        return [];
      }
      console.error('Failed to fetch users:', err);
      if (!signal.aborted) {
        setError(translateApiError(err, 'Failed to fetch users'));
      }
      return [];
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  }, []);

  // Fetch users on mount
  useEffect(() => {
    const controller = new AbortController();
    fetchAllUsers(controller.signal);

    return () => {
      controller.abort();
    };
  }, [fetchAllUsers]);

  // ✅ Refetch function returns a promise now
  const refetch = useCallback(() => {
    const controller = new AbortController();
    return fetchAllUsers(controller.signal); // return promise
  }, [fetchAllUsers]);

  return { users, loading, error, refetch };
}
